<template>
  <div
    v-if="sortOptions.length"
    v-clickoutside="dismissMenu"
    class="product-sort"
    @mouseenter="isOpen = true"
    @mouseleave="isOpen = false">
    <img
      src="/images/icons/sort.svg"
      width="24"
      height="24"
      alt="Sorting products"
      class="product-sort__icon"
      tabindex="0"
      @click="toggleMenu">
    <div
      :class="{ 'product-sort__wrapper--opened': isOpen }"
      class="product-sort__wrapper">
      <div
        class="product-sort__body transition--opacity">
        <div
          v-for="item in sortOptions"
          :key="item.id"
          :class="{ 'product-sort__item--active': activeOption === item.id }"
          class="product-sort__item transition--color"
          tabindex="0"
          @click="emitSortOption(item.id)">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import clickoutside from 'Root/directives/clickoutside';
import ProductSortMobile from './ProductSortMobile.vue';

export default {
  name: 'ProductSort',

  directives: {
    ...clickoutside,
  },

  props: {
    sortOptions: {
      type: Array,
      default: () => ([]),
    },

    activeOption: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  computed: {
    ...mapState(['userDevice']),
  },

  methods: {
    toggleMenu() {
      if (this.userDevice.innerWidth > 600) {
        this.isOpen = !this.isOpen;
      } else {
        this.$vuedals.openMobilePanel({
          component: ProductSortMobile,
          data: {
            sortOptions: { ...this.sortOptions },
            activeOption: this.activeOption,
          },
          onClose: ({ id }) => {
            this.emitSortOption(id);
          },
        });
      }
    },

    emitSortOption(id) {
      if (id === this.activeOption) {
        return;
      }

      if (this.isOpen) {
        this.isOpen = false;
      }

      this.$emit('sortOption', id);
    },

    dismissMenu() {
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .product-sort {
    display: inline-block;
    position: relative;
    z-index: 2;
    padding: 8px;
    margin: -8px;
  }

  .product-sort__icon {
    width: 24px;
    height: auto;
    cursor: pointer;
  }

  @media screen and (max-width: 599px) {
    .product-sort__wrapper {
      display: none;
    }
  }

  @media screen and (min-width: 600px) {
    .product-sort__wrapper {
      padding-top: 20px;
      visibility: hidden;
      opacity: 0;
      position: absolute;
      top: 24px;
      right: -13px;
      min-width: 220px;
      pointer-events: none;
      transition: opacity var(--transition-opacity-time) var(--transition-opacity-easing);
    }

    .product-sort__body {
      padding: 11px 15px;
      background-color: $color--basic-dark-gray;
      display: flex;
      flex-direction: column;
      border-radius: 5px;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: -8px;
        right: 21px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 11px 11px 11px;
        border-color: transparent transparent $color--basic-dark-gray transparent;
      }
    }

    .product-sort__wrapper--opened {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }

    .product-sort__item {
      cursor: pointer;
      font-weight: 500;
      font-size: $text-13px;
      padding: 4px 0;
      margin-bottom: 1px;
      order: 2;

      &:not(.product-sort__item--active):hover {
        color: $color--basic-light-gray;
      }
    }

    .product-sort__item--active {
      order: 1;
      padding-bottom: 12px;
      margin-bottom: 8px;
      border-bottom: 1px solid rgba(168, 187, 219, 0.25);
    }
  }
</style>
